import styled from 'styled-components';

const StyledStar = styled.div`
  display: flex;
  justify-content: space-between;
  width: 124px;
  color: #ffda5b;
  font-size: 18px;
`;

export default StyledStar;
